import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Games.css"; // Reutilizando o mesmo CSS
// Importando imagens
import bacImg from "../../imgs/bacbo.jpg";
import aviator from "../../imgs/aviator.jpeg";
import rouletImg from "../../imgs/MegaRoulet.jpg";
import footballstudio from "../../imgs/footballstudio.jpg";
import HeaderLogo from "../Home/headerLogo";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase-config";
import WhatsAppSupport from "../WhatsAppSupport/WhatsAppSupport";

import { FaPlay } from "react-icons/fa";

function LiveGames() {
  const navigate = useNavigate();
  const [payouts, setPayouts] = useState({});
  const [selectedBets, setSelectedBets] = useState({});
  const [webViewContent, setWebViewContent] = useState(null);
  const [platformCards, setPlatformCards] = useState([]);
  const [gameResults, setGameResults] = useState({});

  // Mapeamento das bets por jogo (apenas jogos ao vivo)
  const betMappings = {
    "Aviator": [0.50, 1.00, 1.50, 2.50, 3.00, 5.00],
    "Bac Bo": [0.50, 1.00, 1.50, 2.50, 3.00, 5.00],
    "Mega Roulette Brasil": [0.50, 1.00, 1.50, 2.50, 3.00, 5.00],
    "Footbal Studio": [0.50, 1.00, 1.50, 2.50, 3.00, 5.00],
  };

  // Lista de jogos ao vivo apenas
  const liveGamesList = [
    {
      name: "Aviator",
      img: aviator,
      category: "Live",
      available: true,
      isLive: true,
    },
    {
      name: "Bac Bo",
      img: bacImg,
      category: "Live",
      available: true,
      isLive: true,
    },
    {
      name: "Mega Roulette Brasil",
      img: rouletImg,
      category: "Live",
      available: true,
      isLive: true,
    },
    {
      name: "Footbal Studio",
      img: footballstudio,
      category: "Live",
      available: true,
      isLive: true,
    },
  ];

  // Função que gera seed baseada em intervalos de 3 minutos + componente de refresh
  const generateSeed = () => {
    const now = Date.now();
    const threeMinutes = 3 * 60 * 1000; // 3 minutos em millisegundos
    const timeBasedSeed = Math.floor(now / threeMinutes) * threeMinutes;
    
    // Adiciona um componente que muda a cada refresh da página
    const refreshComponent = Math.floor(Math.random() * 1000);
    
    return timeBasedSeed + refreshComponent;
  };

  // Função que gera um "random" pseudo-aleatório com base em seed
  const pseudoRandom = (seedValue) => {
    const x = Math.sin(seedValue) * 10000;
    return x - Math.floor(x);
  };

  // Pega o payout (0 a 1) a partir do seed + hash do nome do jogo
  const generatePayout = (seed, gameName) => {
    const value = pseudoRandom(seed + gameName.hashCode());
    return value;
  };

  // Extensão para String para gerar hash
  String.prototype.hashCode = function () {
    let hash = 0;
    if (this.length === 0) return hash;
    for (let i = 0; i < this.length; i++) {
      const char = this.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  };

  // Função para gerar resultados específicos para cada jogo
  const generateGameResults = (seed) => {
    const newResults = {};

    liveGamesList.forEach((game) => {
      switch (game.name) {
        case "Aviator":
          // Gerar multiplicador de 1x a 4x
          const random = generatePayout(seed + 2000, game.name);
          let aviatorMultiplier;
          
          if (random < 0.4) {
            // 40% chance de 1.00x - 2.00x
            aviatorMultiplier = 1.00 + (random / 0.4) * 1.00;
          } else if (random < 0.8) {
            // 40% chance de 2.00x - 3.00x
            aviatorMultiplier = 2.00 + ((random - 0.4) / 0.4) * 1.00;
          } else {
            // 20% chance de 3.00x - 4.00x
            aviatorMultiplier = 3.00 + ((random - 0.8) / 0.2) * 1.00;
          }
          
          newResults[game.name] = `${aviatorMultiplier.toFixed(2)}x`;
          break;
        
        case "Bac Bo":
          // Resultados com apenas 2 cores: vermelho e azul
          const bacBoRandom = generatePayout(seed + 3000, game.name);
          let bacBoResult;
          
          if (bacBoRandom < 0.50) {
            bacBoResult = "Aposte na cor Azul";
          } else {
            bacBoResult = "Aposte na cor Vermelha";
          }
          
          newResults[game.name] = bacBoResult;
          break;
        
        case "Mega Roulette Brasil":
          // Recomendação apenas para Vermelho ou Preto
          const rouletteRandom = generatePayout(seed + 4000, game.name);
          let rouletteResult;
          
          if (rouletteRandom < 0.50) {
            rouletteResult = "Aposte no Vermelho";
          } else {
            rouletteResult = "Aposte no Preto";
          }
          
          newResults[game.name] = rouletteResult;
          break;
        
        case "Footbal Studio":
          // Resultados mais realistas com probabilidades de futebol
          const footballRandom = generatePayout(seed + 5000, game.name);
          let footballResult;
          
          if (footballRandom < 0.50) {
            footballResult = "Aposte na cor Azul";
          } else {
            footballResult = "Aposte na cor Vermelha";
          }
          
          newResults[game.name] = footballResult;
          break;
        
        default:
          newResults[game.name] = "N/A";
      }
    });

    return newResults;
  };

  // Função para gerar payouts e bets aleatórias
  const generateRandomPayoutsAndBets = () => {
    const seed = generateSeed();
    const newPayouts = {};
    const newSelectedBets = {};

    liveGamesList.forEach((game) => {
      // Gerar payout entre 45% e 98%
      const payoutValue = generatePayout(seed, game.name);
      const scaledPayout = 45 + payoutValue * 53; // 45 + (0-1) * 53 = 45-98
      newPayouts[game.name] = scaledPayout.toFixed(2);

      // Selecionar bet aleatória do array de bets do jogo
      const betsArray = betMappings[game.name] || [0.50, 1.00, 1.50, 2.50, 3.00, 5.00];
      const randomBetIndex = Math.floor(generatePayout(seed + 1000, game.name) * betsArray.length);
      newSelectedBets[game.name] = betsArray[randomBetIndex];
    });

    setPayouts(newPayouts);
    setSelectedBets(newSelectedBets);
    
    // Gerar resultados dos jogos
    const results = generateGameResults(seed);
    setGameResults(results);
  };

  // Buscar plataformas do Firebase
  const fetchPlatforms = async () => {
    try {
      const q = query(collection(db, "plataformas"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      const platforms = [];
      querySnapshot.forEach((doc) => {
        platforms.push({ id: doc.id, ...doc.data() });
      });
      setPlatformCards(platforms);
    } catch (error) {
      console.error("Erro ao buscar plataformas:", error);
    }
  };

  useEffect(() => {
    generateRandomPayoutsAndBets();
    fetchPlatforms();

    // Atualizar a cada 3 minutos
    const interval = setInterval(() => {
      generateRandomPayoutsAndBets();
    }, 180000); // 3 minutos

    return () => clearInterval(interval);
  }, []);

  const handleClick = (gameName) => {
    switch (gameName) {
      case "Aviator":
        navigate("/games/aviator");
        break;
      case "Bac Bo":
        navigate("/games/bacbo");
        break;
      case "Mega Roulette Brasil":
        navigate("/games/megaroulet");
        break;
      case "Footbal Studio":
        navigate("/games/football-studio");
        break;
      default:
        console.warn("No route found for:", gameName);
    }
  };

  const handleNewCardClick = (url) => {
    const htmlContent = `
      <iframe src="${url}" width="89%" height="900px"></iframe>
    `;
    setWebViewContent(htmlContent);
  };

  const getProgressBarClass = (payout) => {
    const val = Number(payout);
    if (val <= 45) return "progress-bar red";
    if (val <= 75) return "progress-bar yellow";
    return "progress-bar green";
  };

  return (
    <div className="games-background">
      <HeaderLogo />

      {/* Novos Cards acima do título - DINÂMICO */}
      <div className="games-grid-casa">
        {platformCards.map((p) => (
          <div
            key={p.id}
            className="game-card-casa"
            onClick={() => handleNewCardClick(p.link)}
          >
            <img src={p.imagem} alt={p.nome} />
          </div>
        ))}
      </div>

      <div
        className="webview-container"
        dangerouslySetInnerHTML={{ __html: webViewContent }}
      ></div>

      {/* Título específico para jogos ao vivo */}
      <div className="update-alert">
        <div className="update-alert-icon">
          <FaPlay />
        </div>
        <div className="update-alert-text">
          Jogos Ao Vivo - Atualize a página pelo menos uma vez a cada 3 minutos para ver as atualizações.
        </div>
        <button className="update-alert-close">
          <i className="fas fa-times"></i>
        </button>
      </div>

      {/* Grid de Jogos Ao Vivo */}
      <div className="games-grid">
        {liveGamesList.map((game, index) => (
          <div
            key={index}
            className={`game-card ${!game.available && "disabled"}`}

          >
            {/* Progresso + payout */}
            <div className="game-header">
              <div className="game-payout">{payouts[game.name]}%</div>
              <div className="progress-bar-container">
                <div
                  className={getProgressBarClass(payouts[game.name])}
                  style={{ width: `${payouts[game.name]}%` }}
                ></div>
              </div>
            </div>

            {/* Imagem do jogo */}
            <div className="game-card-content">
              <img src={game.img} className="game-img" alt={game.name} />
              {/* Indicador AO VIVO sempre presente */}
              <div className="live-indicator">
                <span className="live-dot"></span>
                AO VIVO
              </div>
            </div>

            {/* Seção de Resultados */}
            <div className="game-results-section">
              <div className="results-header">
                <span className="results-icon">🎯</span>
                <span className="results-title">Último Resultado</span>
              </div>
              <div className="results-value">
                {gameResults[game.name] || "Carregando..."}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Botão de Suporte WhatsApp */}
      <WhatsAppSupport />
    </div>
  );
}

export default LiveGames;